/**
 * CPV-AI-01 · may this person use the CPV assistant at the plants in view? The server's answer (`allowed` of
 * GET /bp/cpv-ai/suggestions/: POLICY cpv.ai.use at the answering plant), read once per sign-in and location choice and
 * shared by every entry (the menu, "Ask CPV", "Explain this trend", "Summarise signal"). A person without CPV read is
 * never asked about; a failed read hides the entries (and is asked again on the next choice).
 */
import { useEffect, useState } from 'react';
import { accessControlUtils } from '@/components/AccessControlUtils';
import { useScope } from '@/contexts/ScopeContext';
import { getScopeParams } from '@/contexts/scopeStore';
import { CPV_MODULE } from '@/menu-items/cpvMenu';
import { assistantApi } from './assistantApi';

const answers = new Map();   // sign-in token + location choice → Promise<boolean>

function allowedFor(key) {
  if (!answers.has(key)) {
    answers.set(key, assistantApi.suggestions({}).then((d) => d?.allowed === true).catch(() => { answers.delete(key); return false; }));
  }
  return answers.get(key);
}

/** Forget the cached answers (a spec opens several pages in one browser context). */
export const forgetAssistantAllowed = () => answers.clear();

export default function useAssistantAllowed() {
  const { inView, version } = useScope();
  const reads = Boolean(accessControlUtils(CPV_MODULE)?.read_access);
  const key = `${localStorage.getItem('Token') || ''}|${JSON.stringify(getScopeParams())}|${inView.join(',')}|${version ?? ''}`;
  const [allowed, setAllowed] = useState(false);
  useEffect(() => {
    if (!reads) { setAllowed(false); return undefined; }
    let live = true;
    allowedFor(key).then((ok) => { if (live) setAllowed(ok); });
    return () => { live = false; };
  }, [reads, key]);
  return reads && allowed;
}
